var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.477 1.452a1 1 0 01-.813 1.828A8.998 8.998 0 004.16 5.653a8.997 8.997 0 00-.71 10.746 9 9 0 0016.547-4.622l.004-.271v-.93a1 1 0 011.993-.117l.007.117v.93a11 11 0 11-6.524-10.054zm7.23.347a1 1 0 01.084 1.32l-.083.094-11 11a1 1 0 01-1.32.083l-.095-.083-3-3a1 1 0 011.32-1.497l.095.083L11 12.092 21.293 1.799a1 1 0 011.415 0z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidate);
export default __webpack_public_path__ + "static/media/validate.10e919be42cbe47e526dd05c3d4cde7d.svg";
export { ForwardRef as ReactComponent };